import * as ng from 'angular';

import { EditorModel } from '../../editor/editor.model';
import { EditorPageModel } from '../../editor/editor-page.model';
import { Experience, ExperienceTypeDef } from '../../experience.model';
import { L10nService, SessionService } from '../../../../shared';

const settingsViewUrl = require('./join-virtual-settings.html');
const counterViewUrl = require('./join-virtual-counter.html');
const joinViewUrl = require('./join-virtual-join.html');

const headerViewUrl = require('./join-virtual-header.html');
const footerViewUrl = require('./join-virtual-footer.html');

ng.module('e360')
   .factory('joinVirtualEditorModelFactory', joinVirtualEditorModelFactory);

joinVirtualEditorModelFactory.$inject = ['instanceServiceFactory'];
function joinVirtualEditorModelFactory(instanceServiceFactory) {
   return instanceServiceFactory(JoinVirtualEditorModel);
}

export interface joinVirtualEditorModelFactory {
   ({campaign, typeDef:ExperienceTypeDef, experience:Experience}):JoinVirtualEditorModel
}

export class JoinVirtualEditorModel extends EditorModel {
   readonly workspaceClass = 'join-virtual';

   readonly settingsView = settingsViewUrl;
   readonly headerViewUrl = headerViewUrl;
   readonly footerViewUrl = footerViewUrl;

   readonly pages:JoinVirtualPageModel[];

   static $inject = [
      'session', 'l10n', 'gettextCatalog',
   // separating instance args from injected services
   ].concat(['campaign', 'typeDef', 'experience']);

   constructor(
      private session:SessionService,
      l10n:L10nService,
      gettextCatalog,
      campaign, typeDef: ExperienceTypeDef, experience: Experience
   ) {
      super(campaign, typeDef, experience);

      this.hasSettings = true;
      this.hasPages = true;
      this.hasStaticPages = true;
      this.hasPreview = true;
      this.previewUrl = `//${this.session.joinVirtualDomain()}/preview/${this.session.getCampaign().slug}`;

      this.pages = [
         new JoinVirtualPageModel(this, counterViewUrl),
         new JoinVirtualPageModel(this, joinViewUrl)
      ];

      if (this.isNew) {
         let brandSettings = this.session.getBrand().settings.experience;

         let defaults = {
            // titles
            titleFont: brandSettings.mediaFont,
            titleFontSize: brandSettings.headerFontSize,
            subTitleFontSize: brandSettings.fontSize,
            titleFontColor: brandSettings.headerFontColor,
            // body
            font: brandSettings.mediaFont,
            fontSize: brandSettings.fontSize,
            fontColor: brandSettings.fontColor,
            accentColor: brandSettings.linkColor,
            linkHoverColor: brandSettings.linkHoverColor,
            buttonTextColor: brandSettings.buttonTextColor,
            backgroundColor: brandSettings.backgroundColor,
            // footer
            mirrorCampaignFooter: true,
            footerFontSize: brandSettings.footerFontSize,
            footerFontColor: brandSettings.footerFontColor,
            footerLinkColor: brandSettings.footerLinkColor,
            footerLinkHoverColor: brandSettings.footerLinkHoverColor,
            footerBackgroundColor: brandSettings.footerBackgroundColor,
            uploads: { headerImage: brandSettings.uploads.genericHeader }
         };

         this.experience = {
            campaignId: campaign.id,
            type: typeDef.id,
            settings: ng.copy(defaults)
         };
      }

      gettextCatalog.getString('The event starts in:');
      l10n.translateObject(
         this.experience.settings,
         'counterText',
         'The event starts in:',
         this.languages
      );

      gettextCatalog.getString('This event has started. Join Now!');
      l10n.translateObject(
         this.experience.settings,
         'joinText',
         'This event has started. Join Now!',
         this.languages
      );
   }
}

export class JoinVirtualPageModel extends EditorPageModel {
   readonly view:string;

   constructor(editor:JoinVirtualEditorModel, view:string) {
      super(editor);
      this.view = view;
   }

   get settings() {
      return null;
   }
}
